class AlgoliaProductBadge extends HTMLElement {
  constructor() {
    super();

    this.connectedCallback = this.connectedCallback.bind(this);
    this.getStyle = this.getStyle.bind(this);
    this.render = this.render.bind(this);
  }

  /**
   * Initializes settings based on custom attributes when the element is connected to the DOM.
   * @returns {void}
   */
  connectedCallback() {
    this.settings = {
      productBadgeBackgroundColor: this.getAttribute('product-badge-background-color'),
      productBadgeBorderColor: this.getAttribute('product-badge-border-color'),
      productBadgeBorderWidth: this.getAttribute('product-badge-border-width'),
      productBadgeButtonRadius: this.getAttribute('product-badge-button-radius'),
      productBadgeTextColor: this.getAttribute('product-badge-text-color')
    }
  }

  /**
   * Returns the CSS styles.
   * @returns {string} The CSS style block as a string.
   */
  getStyle() {
    const style = document.createElement('style');
    const css = `
        #product__badge * {
          color: ${this.settings.productBadgeTextColor};
        }

        .product__badge {
          display: inline-block;
          text-align: center;
          z-index: 1;
          margin: 0;
          background-color: ${this.settings.productBadgeBackgroundColor};
          border-radius: ${this.settings.productBadgeButtonRadius}px;
          border: ${this.settings.productBadgeBorderWidth}px solid ${this.settings.productBadgeBorderColor};
          color: ${this.settings.productBadgeTextColor};
        }

        .product__badge span {
          white-space: nowrap;
          text-transform: uppercase;
        }

        .product__badge--top {
          top: 0;
        }

        .product__badge--bottom {
          bottom: 0;
        }

        .product__badge--left {
          left: 0;
        }

        .product__badge--center {
          left: 50%;
          transform: translateX(-50%);
        }

        .product__badge--right {
          right: 0;
        }
    `;

    style.appendChild(document.createTextNode(css));

    return style;
  }

  /**
   * Renders the product badge content.
   * @param {string} label - The span label.
   * @returns {string} The rendered product badge.
   */
  render(label) {
    const style = this.getStyle();

    const div = document.createElement('div');
    const span = document.createElement('span');
    span.textContent = label;
    div.appendChild(span);

    return [style, div];
  }
}

customElements.define("algolia-product-badge", AlgoliaProductBadge);